<template>
  <div class="view-144">
    <div class="view-145">
      <div class="text-197 fontawesome5free-solid-normal-black-20px"></div>
      <div class="text-198 poppins-semi-bold-black-20px">Практика</div>
      <writing />
    </div>
  </div>
</template>

<script>
import Writing from "./Writing";
export default {
  name: "View662",
  components: {
    Writing,
  },
};
</script>

<style>
.view-144,
.view-146,
.view-148 {
  align-items: center;
  display: flex;
  width: 167px;
}

.view-145,
.view-147,
.view-149 {
  height: 30px;
  position: relative;
  width: 171px;
}

.text-197,
.text-210,
.text-222 {
  left: 157px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 10px);
  white-space: nowrap;
}

.text-198,
.text-211,
.text-223 {
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 0;
}
</style>
